import { render, staticRenderFns } from "./PostBoxIndex.vue?vue&type=template&id=0939edf6"
import script from "./PostBoxIndex.vue?vue&type=script&lang=js"
export * from "./PostBoxIndex.vue?vue&type=script&lang=js"
import style0 from "./PostBoxIndex.vue?vue&type=style&index=0&id=0939edf6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports